import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Toast } from '../../models/toast.model';
import { ToasterService } from '../../services/toast.service';
import { BehaviorSubject } from 'rxjs';
import { ToastComponent } from '../toast/toast';

@Component({
	selector: 'app-toaster',
	standalone: true,
	imports: [CommonModule, ToastComponent],
	templateUrl: './toaster.html',
})
export class ToasterComponent implements OnInit {
	toasts$: BehaviorSubject<Toast[]> = new BehaviorSubject<Toast[]>([]);
	@Output() toastRemoved = new EventEmitter<string>();

	toasterService: ToasterService = inject(ToasterService);

	ngOnInit() {
		this.toasterService.toasts$.subscribe((toasts) => {
			this.toasts$.next(toasts);
		});
	}

	removeToast(id: string): void {
		const index = this.toasts$.value.findIndex((toast) => toast.id === id);
		if (index !== -1) {
			const updatedToasts = [...this.toasts$.value];
			updatedToasts[index].removing = true;
			this.toasts$.next(updatedToasts);

			// set to match fade-out animation duration
			setTimeout(() => {
				this.toasterService.removeToast(id);
			}, 500);
		}
	}

	trackByFn(index: number, toast: Toast): string {
		return toast.id;
	}
}
